import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import useStaticImage from './useStaticIcon';
import { ImageIcons } from '../../../types/image-icon-types';

interface IImageIconProps {
  type: ImageIcons;
  className?: string;
}

const ImageIcon = ({
  type,
  className,
}: IImageIconProps) => {
  const image = useStaticImage(type);
  const pluginImage = getImage(image);

  if (!pluginImage) {
    return <div className={className}>Image not found</div>;
  }
  return <GatsbyImage image={pluginImage} loading="eager" alt={`${type} icon`} className={className} imgStyle={{ transition: 'none' }} />

};

export default ImageIcon;
